import { render } from "./ReportsDashboard.vue?vue&type=template&id=2ba7343d&scoped=true"
import script from "./ReportsDashboard.vue?vue&type=script&lang=js"
export * from "./ReportsDashboard.vue?vue&type=script&lang=js"

import "./ReportsDashboard.vue?vue&type=style&index=0&id=2ba7343d&lang=css"
import "./ReportsDashboard.vue?vue&type=style&index=1&id=2ba7343d&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba7343d"]])

export default __exports__